export class ResponseVM {
  success: boolean | null;
  error: string | null;
  data: any | null;
  constructor() {
    this.success = false;
    this.error = null;
    this.data = null;
  }
}